exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .main-content {\n  height: 100%;\n  padding: 0; }\n  :host .main-content .main-content-wrap {\n    height: 100%;\n    padding: 0;\n    width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/layouts/extra/extra.component.scss
// module id = ../../../../../src/app/layouts/extra/extra.component.scss
// module chunks = 39